import './polyfills';
// import { scan } from 'react-scan';

import { createRoot } from 'react-dom/client';
import 'typeface-roboto';
import App from './App';
import './index.css';
import '@shadcn/ui/lib/utils/global.css';
import '@assistant-ui/styles/index.css';
import '@assistant-ui/styles/modal.css';
import '@assistant-ui/styles/markdown.css';

// import * as serviceWorker from './serviceWorker';
import LogRocket from 'logrocket';
if (import.meta.env.MODE === 'production') {
    LogRocket.init('kdqs9m/appzaplify', { ingestServer: 'https://core5.andsend.com/la' });
}
workaroundForNotCrashingWhenTranslated();
// scan({
//     enabled: true,
// });
const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        // Unregister the specific service worker
        navigator.serviceWorker
            .getRegistrations()
            .then((registrations) => {
                registrations.forEach((registration) => {
                    if (registration.active && registration.active.scriptURL.includes('/serviceWorker1.js')) {
                        registration.unregister().then(() => {
                            console.log('Old service worker unregistered');
                        });
                    }
                });
            })
            .then(() => {
                navigator.serviceWorker
                    .register('/serviceWorker1.js')
                    .then((registration) => {
                        console.log('Service Worker registered with scope:', registration.scope);
                    })
                    .catch((error) => {
                        console.error('Service Worker registration failed:', error);
                    });
            });
    });
}

/** https://github.com/facebook/react/issues/11538#issuecomment-417504600 */
function workaroundForNotCrashingWhenTranslated() {
    // This is a workaround to prevent the app from crashing when the user changes the language
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        // @ts-ignore
        Node.prototype.removeChild = function (child) {
            if (child.parentNode !== this) {
                if (console) {
                    console.error('Cannot remove a child from a different parent', child, this);
                }
                return child;
            }
            // @ts-ignore
            return originalRemoveChild.apply(this, arguments);
        };

        const originalInsertBefore = Node.prototype.insertBefore;
        // @ts-ignore
        Node.prototype.insertBefore = function (newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                }
                return newNode;
            }
            // @ts-ignore
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
